module.exports = __webpack_public_path__ + "static/media/webchat.d596be4f.svg";